module.exports = __webpack_public_path__ + "static/media/wedding-rings.ccc643fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/wedding-rings.svg
// module id = 1609
// module chunks = 50